import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../hooks/app'
import { getUser, logoutUser } from '../store/slices/auth-slice'
import { useNavigate } from 'react-router-dom'

function AdminPagesProvider({ children }: { children: React.ReactNode }) {
    const [loadPage, setLoadPage] = useState<boolean>(false)
    const user = useAppSelector(getUser)
    const navigate = useNavigate()

    useEffect(() => {
        if (!user?.isSuperuser && !user.isStaff ) {
            navigate("/forbidden")
        }
        setLoadPage(true)
    }, [user])

    return (
        <>
            {loadPage ? <div>{children}</div> : null}
        </>
    )
}

export default AdminPagesProvider